import React from "react";
import { Multiselect } from "multiselect-react-dropdown";
import '../css/dropdown.css';

/**
 * ABOUT THIS COMPONENT
 * This component allows to handle some more functionalities in regards to Airbus Standard Combobox:
 * - Allow the user to Select / Unselect All items
 * - Allow to group by item field
 * - Allow to search by multiple field names
 * 
 * 
* 
<CustomMultiSelect
    key= (string)       Component KEY 
    displayValue=       (string or string[]) Field name(s) to display in options
                        if multiple display value => options will concatenate the fields
                        i.e : for data {label:xxx, type:'yyy',...} and displayValue=['type', 'label']
                              output: <option>xxx - yyy</option>
                              This is useful if we need to search on multiple fields to select values  
    id=                 (string) Field value
    groupBy=            (string) Field name on which data must be grouped by 
    options=            (Object[]) List of options: ex: {"uuid": xxx, "name": "ABC", "type": "typeXXX"}
    selectedValues=     (Object[]) List of selected options
    multiple=           (bool) default true => allow multiple selection
    selectAll=          (bool) default true => add select all / unselect option
    callBack=           (Object) Your callBack on select / unselect {this.handleCallBack(selected_options, multiselect ref object)}
                                 
/>
 * 
 * 
*/




/**
 * Custom Multi Select Component
 * @category Component
 */
class CustomMultiSelect extends React.Component {

    /**
     * CONSTRUCTOR
     */
    constructor(props)  {
        super(props);
        let _ =require("underscore");
        
        
        this.ref = React.createRef();
        this.key= props.mykey;
        this.displayValue= props.displayValue;
        this.selectAll = props.selectAll!==undefined ? props.selectAll : true; 
        this.unSelectAll=props.unSelectAll!==undefined ? props.unSelectAll : true;
        let options = props.options;
        let selectedValues = props.selectedValues;
        
        

        //Check if we have multiple values to display
        if(Array.isArray(this.displayValue)){
            //set new display value field key
            this.displayValue = this.displayValue.join("_");

            //reformat options
            options=_.map(options, function(option){
                let new_option=null;
                let new_value= null;
                _.each(props.displayValue, function(key){
                    if(!new_option){
                        new_option = key
                        new_value = option[key];
                    }else{
                        new_option = new_option+"_"+key;
                        if(option[key] !== undefined){
                            new_value = new_value+" - "+option[key]
                        }
                    }

                });

                option[new_option]=new_value;

                return option

            }, props);

            // and selected values
            selectedValues = _.map(selectedValues, function(option){
                let new_option=null;
                let new_value= null;
                _.each(props.displayValue, function(key){
                    if(!new_option){
                        new_option = key
                        new_value = option[key];
                    }else{
                        new_option = new_option+"_"+key;
                        if(option[key] !== undefined){
                            new_value = new_value+" - "+option[key]
                        }
                    }

                });

                option[new_option]=new_value;

                return option

            }, props);

        }


        this.id=props.id;
        this.groupBy=props.groupBy;

        this.multiple = props.multiple!==undefined ? props.multiple : true; //default is multiple selection
        //this.selectAllInSearch = props.selectAllInSearch !== undefined ? props.selectAllInSearch : false //Default is false for select all display chen searching a term

        this.state = {
            options : options,
            selectedValues:selectedValues
        }


        this.__isSelectAllFormatted = false;


    }


    componentDidMount(){
        this.onChangeSetCustomDisplay( [], this.ref);
    }


    componentWillUpdate(nextProps, nextState){
        /*if(JSON.stringify(nextState) !== JSON.stringify(this.state)){
            return true;
        }*/

        if(JSON.stringify(nextProps) === JSON.stringify(this.props)){
            return false;
        }
        else{
            let _=require("underscore");
            
            
            //reformat options
            let options=_.map(nextProps.options, function(option){
                let new_option=null;
                let new_value= null;
                _.each(nextProps.displayValue, function(key){
                    if(!new_option){
                        new_option = key
                        new_value = option[key];
                    }else{
                        new_option = new_option+"_"+key;
                        if(option[key] !== undefined){
                            new_value = new_value+" - "+option[key]
                        }
                    }

                });

                option[new_option]=new_value;

                return option

            }, nextProps);
            
            let selectedValues = _.map(nextProps.selectedValues, function(option){
                let new_option=null;
                let new_value= null;
                _.each(nextProps.displayValue, function(key){
                    if(!new_option){
                        new_option = key
                        new_value = option[key];
                    }else{
                        new_option = new_option+"_"+key;
                        if(option[key] !== undefined){
                            new_value = new_value+" - "+option[key]
                        }
                    }

                });

                option[new_option]=new_value;

                return option

            }, nextProps);

            this.setState({selectedValues: selectedValues, options:options});
        }

    }





    /**
     * RENDERING
     */

    render(){

        return(
            <div>
            {this.state.options && this.state.options.length >0 &&

            <Multiselect                 
                ref={this.ref}
                key={this.key}
                name={this.key}
                className="w-288"
                options={this.state.options}
                onSelect={this.onChangeSelect}
                onRemove={this.onChangeSelect}
                onSearch={(v)=>this.onSearch(v, this.ref)}
                selectedValues={this.state.selectedValues}
                selectedValueDecorator={(v)=>this.onChangeSetCustomDisplay(v, this.ref)}
                optionValueDecorator = {(v)=>this.optionValueDecorator(v, this.ref)}
                displayValue={this.displayValue}
                selectionLimit={this.multiple===true ? null : 1}
                id={this.id}
                groupBy={this.groupBy}
                singleSelect={false}
                hideSelectedList={false}
                hidePlaceholder={true}
                showArrow={true}
                showCheckbox={this.multiple===true ? true : false}
                keepSearchTerm={false}
                customCloseIcon={"   "}                
                closeOnSelect={true}     
                     
            /> 
            }

            </div>

        )


    }


    onSearch = (event, ref) => {
        return this.props.callBackEmpty ? this.props.callBackEmpty(event, ref) : null;
    }


    /**
     * on ComboBox Location Selected keys Changed 
     * 
     */
    onChangeSelect = async (event) =>{
        //let new_selected_values = this.manageSelectUnselectAll(event, this.state.options);
        let new_selected_values = event;

        //set selected option and send call back to parent component
        this.setState({selectedValues:new_selected_values},
            
            //Fire Callback to parent component
            await this.props.callBack(new_selected_values, this.ref)

            );


    }



     /**
     * Change Custom Display: Modify drop down visualization (add Chip +n if too many data selected)  
     * @param {Object} v : selected / unselected object
     */
    onChangeSetCustomDisplay(v, ref){

        if(ref.current === null){
            return
        }
        
        let limit=1 //Max display items
        //debugger;
        //get number of items selected
        let countSelected=ref.current.getSelectedItemsCount();
        let selectedItems = ref.current.getSelectedItems();

        let chips= ref.current.searchWrapper.current.getElementsByTagName('span');
        
        if(countSelected > limit){

            for(let i=0;i<chips.length;i++){
                if((i===limit)){
                    let chip_style = chips[i].style;
                    chips[i].innerHTML =  ' + '+String(countSelected) + ' items'
                    chips[i].style = chip_style;
                    chips[i].style.display='initial'; 
                }
                else {
                    chips[i].style.display='None'
                }
                
            }
        }else{
            for(let i=0;i<chips.length;i++){
                chips[i].style.display='initial';

                if(selectedItems[i] !== null && selectedItems[i]!== undefined){
                    let childNodes=Object.assign([], chips[i].childNodes);
                    let chip_style = chips[i].style;
                    chips[i].innerHTML=selectedItems[i][this.displayValue];
                    chips[i].style=chip_style

                    //re display delete button
                    for (let j=0; j< childNodes.length; j++){
                        if(childNodes[j].tagName === 'I'){
                            chips[i].appendChild(childNodes[j])
                        }
                    }
                }
            }
        }
        
    }



    /**
     * Set Options format
     * @param {object} v 
     * @param {object} ref Mulitiselect Reference 
     */
    optionValueDecorator(v, ref){
        
        //Format Select All / Unselect All       
        
        if(this.multiple && (this.selectAll || this.unSelectAll)){
            let options= ref.current.searchWrapper.current.parentElement.getElementsByClassName('optionListContainer')[0].getElementsByClassName('optionContainer')[0].getElementsByClassName("groupChildEle option");
            if(!this.__isSelectAllFormatted && options.length >0){
                
                this.addSearchSelectAllUnselectAll(null);            
                this.__isSelectAllFormatted = true; //avoid reformatting at any change
            }
        }

        return v;

        
    }




    /**
     * Add Select All / Unselect All within multiple comboBox
     * @param {*} v : not used
     * @returns 
     */
    addSearchSelectAllUnselectAll(v){

        let container = this.ref.current.searchWrapper.current.parentElement.getElementsByClassName('optionListContainer');
        let options= container[0].getElementsByClassName('optionContainer')[0].getElementsByClassName("groupChildEle option");
        
        let selectAllExist = document.getElementsByClassName('multiple-selectall')

        if(selectAllExist.length > 0){
            return
        }

        if(options !== null && options !== undefined && options.length > 0){
            const newLi = document.createElement("li");
            newLi.classList.add("multiple-selectall");
            
            let newContent, newHref_selectall, newHref_unselectall;

            //create href SelectAll element
            if(this.selectAll){
                newHref_selectall=document.createElement("a");
                newHref_selectall.classList.add("multiple-selectall-href");
                newContent=document.createTextNode("Tout sélectionner");
                newHref_selectall.appendChild(newContent)
            }

            //create href UnSelectAll element
            if(this.unSelectAll){
                newHref_unselectall=document.createElement("a");
                newHref_unselectall.classList.add("multiple-selectall-href");
                newContent=document.createTextNode("Tout déselectionner");
                newHref_unselectall.appendChild(newContent);
            }

            if(this.selectAll){
                //select all event
                newHref_selectall.addEventListener("click", () => this.handleOnSelectMultiple('select'));
            }

            if(this.unSelectAll){
                //unselect all event
                newHref_unselectall.addEventListener("click", () => this.handleOnSelectMultiple('unselect'));
            }

            //Append to list
            if(this.selectAll){
                newLi.appendChild(newHref_selectall);
            }

            if(this.unSelectAll){
                newLi.appendChild(newHref_unselectall);
            }

            //add to options
            options[0].parentNode.insertBefore(newLi,options[0])

        }

        



    }


    /**
     * Handle SelectAll / Unselect All
     * @param {String} type: select / unselect 
     */
    async handleOnSelectMultiple(type) {
        
        let _ = require('underscore');

        
        let selectedValues = this.ref.current.state.selectedValues;
        let options = this.ref.current.state.options;

        //select All
        if(type === 'select'){
            let input_value = this.ref.current.searchWrapper.current.getElementsByClassName('searchBox')[0].value;
            
            let newSelection;
            if(input_value === ''){
                newSelection = this.state.options; 
            }else{
                newSelection = _.filter(this.state.options, function(item){
                    return item[this.displayValue].toLowerCase().includes(input_value.toLowerCase())
                }, this);
            }

            
            if(newSelection !== undefined){
                this.ref.current.setState({selectedValues:newSelection}, //Fire Callback to parent component
                    async ()=>{
                        await this.props.callBack(newSelection, this.ref);
                        this.onChangeSetCustomDisplay(null, this.ref);
                    });
            }
            
            
            //close list
            //this.ref.current.toggelOptionList()
        }

        //Unselect All
        else if(type === "unselect"){
            if(options.length > 0){
                options = _.map(options, function(item){
                    return item.label
                })

                let newSelection = _.reject(selectedValues, function(item){
                    if(options.includes(item.label)){
                        return item
                    }
                })
                this.ref.current.setState({selectedValues:newSelection},
                    await this.props.callBack(newSelection, this.ref));
            }
            
        }
        
    }


}
export default CustomMultiSelect;